/* eslint-disable import/prefer-default-export */
/**
 * * Adapted from the original function in the PDP Backbone code
 *
 * @description
 * From high level perspective there is inconsitency between selected UPC(sku) utag messsage event
 * But that's an existing behaviour from Backbone
 *
 * @param {Object} options
 * @param {import('@common-vue/media-card-large/src/composables/useUpc/types').UseUpc.Upc} options.upc
 * @param {boolean} options.marketPlaceEnabled
 * @returns {string[]}
 */
export const getAvailabilityMessage = ({
  upc,
  marketPlaceEnabled = false,
}) => {
  if (!upc) {
    return ['this product is currently unavailable'];
  }
  const { seller, marketplaceFlag, availability } = upc;
  if (marketPlaceEnabled && marketplaceFlag && seller?.sellerName) {
    if (availability.available) {
      return availability.lowAvailability ? [`just a few left: shipped by marketplace in ${availability.shipDays} days`] : [`Shipped by marketplace in ${availability.shipDays} days`];
    }
    return ['this product is currently unavailable'];
  }
  if (Array.isArray(availability.availabilityMessage)) {
    return availability.availabilityMessage;
  }
  return [availability.availabilityMessage];
};
